module.exports = __webpack_public_path__ + "assets/french.7a3a86e2d5b131c3c399bf050b12c309.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/french.png
// module id = 624
// module chunks = 0